import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingUnpostedDocumentResource } from "@exonn/js-sdk";

/**
 * "Belege ohne aktuelle Buchung" (S1): Ausgangsrechnungen und Gutschriften, deren Buchung
 * fehlt oder veraltet ist, mit dem zuletzt erfassten Grund. Reine Liste – behoben wird
 * am Beleg bzw. an der Kontierung, nicht hier.
 */
export const module: ModuleOptions<AccountingUnpostedDocumentResource> = {
  resource: ResourceEnum.AccountingUnpostedDocument,
  bigIcon: <span className={"icon-20-document"} />,
  smallIcon: <span className={"icon-15-document"} />,
  disableCreate: true,
  disableDelete: true,
  disableEdit: true,
};
